import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Button } from 'antd';

export default class AppButton extends Component {
    render() {
        const { children, style } = this.props;
        console.dir(children);
        return (
            <div>
                <Button type='primary' style={{ ...style }} onClick={this.props.onClick}>{children}</Button>
            </div >
        )
    }
}

AppButton.propTypes = {
    children: PropTypes.any,
    child: PropTypes.any,
    style: PropTypes.any,
    // guid: PropTypes.string,
    // collectionId: PropTypes.any,
    onClick: PropTypes.func,
}